<template>
  <el-dialog
    title="选择案件生成检索报告"
    :visible.sync="visible"
    custom-class="case-report-creator-modal"
    width="800px"
    :before-close="(done) => (submitLoading ? '' : done())"
  >
    <div
      v-if="isEmpty"
      style="padding: 30px; text-align: center"
      v-loading="initLoading"
    >
      <div class="icon-middle" style="width: 90px">
        <img :src="emptyImg" alt="" />
      </div>
      <div
        class="word-color3"
        style="width: 200px; margin: 20px auto; line-height: 22px"
      >
        <span>您还没有添加案例，请点击“添加检索报告”完成添加</span>
      </div>
    </div>
    <div class="case-report-creator" v-else>
      <el-input
        v-model="title"
        placeholder="请输入检索报告名称"
        :style="{ marginBottom: '20px' }"
      />
      <div
        class="case-report-group"
        v-for="groupItem in groupArr"
        :key="groupItem.searchId"
      >
        <div class="case-report-group-header">
          <i
            class="expand-icon"
            :class="
              groupItem.expandShow
                ? 'el-icon-caret-bottom'
                : 'el-icon-caret-right'
            "
            @click="groupItem.expandShow = !groupItem.expandShow"
          ></i>
          <span v-if="groupItem.condition.length < 1">案例遴选</span>
          <template v-else>
            <span>检索条件：</span>
            <div class="filter-arr">
              <div
                class="filter-item"
                v-for="(courseTipItem, courseTipIndex) in getCourseFilterTips(
                  groupItem.condition,
                  paragraphArr
                )"
                :key="courseTipIndex"
              >
                <span>{{ courseTipItem.tipText }}</span>
              </div>
            </div>
          </template>
        </div>
        <div class="case-report-case-ul" v-show="groupItem.expandShow">
          <div
            class="case-item"
            v-for="caseItem in groupItem.caseArr"
            :key="caseItem.id"
          >
            <div class="case-header">
              <el-checkbox v-model="caseItem.isCheck"></el-checkbox>
              <div class="case-header-title">{{ caseItem.base_title }}</div>
              <div class="case-header-time">{{ caseItem.createTime }}</div>
            </div>
            <div class="case-info">
              <div class="case-info-text">{{ caseItem | caseInfoFilter }}</div>
              <i
                class="el-icon-delete del-icon"
                @click="resetHandle({ id: caseItem.id, groupItem })"
              ></i>
            </div>
          </div>
        </div>
      </div>

      <vipCreator
        v-if="expiredModal.show"
        :show.sync="expiredModal.show"
        :limitType="expiredModal.limitType"
        :justClose="expiredModal.justClose"
        vipType="case"
      />
    </div>
    <span slot="footer" v-if="!isEmpty">
      <div class="case-report-creator-tools">
        <el-checkbox
          :value="allChecked"
          :style="{ marginTop: '9px', float: 'left' }"
          @change="allCheckHandle"
          >全选</el-checkbox
        >
        <el-button @click="resetHandle()">清空列表</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitHandle"
          >立即生成检索报告</el-button
        >
      </div>
    </span>
  </el-dialog>
</template>

<script>
import emptyImg from "@/assets/暂无数据.png";
import { services } from "@/service";
import publicUtilFunc from "@/common/js/publicUtil";
import { usedLimitErrCode, projectInfoConfig } from "@/constant";
import vipCreator from "@/components/vipCreator";
import { sortBy } from 'lodash';

const publicUtil = publicUtilFunc();
const caseInfoKeys = [
  "base_caseType",
  "procedureType",
  "base_nature",
  "base_caseNumber",
  "base_court",
  "judgementDate",
];

export default {
  components: { vipCreator },
  data() {
    return {
      emptyImg,
      title: "",
      initLoading: false,
      submitLoading: false,
      groupArr: [],
      paragraphArr: [],
      expiredModal: {
        show: false,
        limitType: "",
        justClose: false,
      },
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    caseInfoFilter(caseItem) {
      const textArr = [];
      caseInfoKeys.forEach((key) => {
        if (caseItem[key]) {
          textArr.push(caseItem[key]);
        }
      });
      return textArr.join(" | ");
    },
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
    isEmpty() {
      return this.groupArr.length < 1;
    },
    allChecked() {
      return this.groupArr.every((groupItem) => {
        return groupItem.caseArr.every((caseItem) => caseItem.isCheck);
      });
    },
    effGroupArr() {
      return this.groupArr
        .map((groupItem) => {
          const caseArr = groupItem.caseArr.filter(
            (caseItem) => caseItem.isCheck
          );
          return { ...groupItem, caseArr };
        })
        .filter((groupItem) => groupItem.caseArr.length > 0);
    },
  },
  watch: {
    "$store.getters.reportCases"(val) {
      this.initHandle(val);
    },
  },
  async mounted() {
    this.initLoading = true;
    const [paragraphArr] = await Promise.all([
      services.labelRelation.getParagraph(),
      this.$store.dispatch("refreshReportCases"),
    ]);
    this.paragraphArr = paragraphArr;
    this.initLoading = false;
  },
  methods: {
    getCourseFilterTips(filterList, paragraphArr) {
      return publicUtil.fetchCourseFilterTips({
        // instrumentType: this.instrumentType,
        filterList,
        paragraphArr,
      });
    },
    initHandle(reportCases) {
      const groupEnum = {};
      const groupArr = [];

      reportCases.forEach((item) => {
        if (!groupEnum[item.searchId]) {
          groupEnum[item.searchId] = {
            caseArr: [],
            expandShow: true,
            searchId: item.searchId,
            condition: JSON.parse(item.condition),
            statisticsJson: JSON.parse(item.statisticsJson),
          };
          groupArr.push(groupEnum[item.searchId]);
        }
        const caseItem = {
          isCheck: true,
          id: item.id,
          caseId: item.caseId,
          base_title: item.base_title,
          createTime: item.createTime,
        };
        caseInfoKeys.forEach((key) => {
          if (item[key]) {
            caseItem[key] = item[key];
          }
        });
        groupEnum[item.searchId].caseArr.push(caseItem);
      });

      this.groupArr = sortBy(groupArr, o => (o.condition.length > 0 ? 0 : 1));
    },
    allCheckHandle() {
      const isCheck = !this.allChecked;
      this.groupArr.forEach((groupItem) => {
        groupItem.caseArr.forEach((caseItem) => {
          caseItem.isCheck = isCheck;
        });
      });
    },
    async resetHandle(options = null) {
      let result = null;
      if (options) {
        result = await services.caseRule.delReportCase(options.id);
      } else {
        await this.$confirm("是否确认清空检索列表");
        result = await services.caseRule.delReportCase();
      }
      if (result.statusCode === 1) {
        if (options) {
          this.$message.success("成功删除案件");
          const idx = options.groupItem.caseArr.findIndex(
            (caseItem) => caseItem.id === options.id
          );
          options.groupItem.caseArr.splice(idx, 1);
          if (options.groupItem.caseArr.length < 1) {
            this.groupArr = this.groupArr.filter(
              (groupItem) => groupItem !== options.groupItem
            );
          }
        } else {
          this.$message.success("清除成功");
          this.groupArr = [];
        }
      }
      this.$store.dispatch("refreshReportCases");
    },
    async submitHandle() {
      if (!this.title) {
        this.$message.error("请输入检索报告名称");
        return;
      }
      if (this.effGroupArr.length < 1) {
        this.$message.error("请至少选择一个案件");
        return;
      }
      try {
        this.submitLoading = true;
        services.logger.handleLog({ operateName: "生成检索报告" });

        const queryArr = this.effGroupArr.map((groupItem) => {
          const caseIds = groupItem.caseArr.map((caseItem) => caseItem.caseId);
          let statisticsJson = groupItem.statisticsJson;
          let conditionStr = "";
          let condition = "";
          condition = JSON.stringify(groupItem.condition);
          statisticsJson = JSON.stringify(statisticsJson);
          conditionStr = this.getCourseFilterTips(
            groupItem.condition,
            this.paragraphArr
          )
            .map((tipItem) => `【${tipItem.tipText}】`)
            .join(" + ");
          return { caseIds, statisticsJson, conditionStr, condition };
        });

        const { statusCode, data } = await services.caseRule.createReport({
          title: this.title,
          queryArr,
          user_id: JSON.parse(localStorage.getItem('userInfo')).id,
          reportMode: 'normal',
          queryArrMerge: []
        });
        if (statusCode !== 1) {
          if (statusCode === usedLimitErrCode) {
            this.expiredModal = {
              show: true,
              limitType: data,
              justClose: true,
            };
          }
          this.submitLoading = false;
          return;
        }

        this.$message.success("报告生成成功");
        await new Promise((resolve) => setTimeout(resolve, 500));

        this.submitLoading = false;
        this.visible = false;

        const { href } = this.$router.resolve({
          path: "/case/report",
          query: {
            reportId: data.id,
          },
        });
        if (projectInfoConfig.crossOriginIFrame) {
            window.location.href = href;
        } else {
            window.open(href, '_blank');
        }
      } catch (err) {
        this.submitLoading = false;
        this.$message.error(err.message);
      } finally {
        this.$store.dispatch("refreshReportCases");
      }
    },
  },
};
</script>

<style lang="less">
.case-report-creator-modal {
  .el-dialog__header {
    padding: 12px 20px 8px;
    border-bottom: 1px solid #e6e6e6;

    .el-dialog__headerbtn {
      top: 16px;
    }
  }
}
</style>

<style lang="less" scoped>
.case-report-creator {
  max-height: 600px;
  overflow: auto;

  .case-report-group {
    margin-bottom: 10px;
    .case-report-group-header {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #666666;
      line-height: 20px;

      .expand-icon {
        color: #222222;
        padding: 3px 5px;
        padding-left: 0;
        cursor: pointer;
      }

      .filter-arr {
        flex: 1;
        width: 0;
        overflow: auto;
        white-space: nowrap;

        &::-webkit-scrollbar {
          display: none;
        }

        .filter-item {
          display: inline-block;
          line-height: 30px;
          padding: 0 12px;
          background: #f5f5f5;
          border-radius: 4px;
          margin-right: 8px;
        }
      }
    }
    .case-report-case-ul {
      .case-item {
        margin-top: 10px;
        border-radius: 4px;
        border: 1px solid #e6e6e6;
        padding: 16px;

        .case-header {
          display: flex;
          align-items: center;
          .el-checkbox {
            margin-right: 8px;
          }
          .case-header-title {
            flex: 1;
            width: 0;
            font-size: 14px;
            color: #222;
            line-height: 20px;
            font-weight: bold;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
          .case-header-time {
            color: #999999;
            line-height: 20px;
            font-size: 12px;
            margin-left: 10px;
          }
        }

        .case-info {
          display: flex;
          align-items: flex-start;
          margin-top: 10px;

          .case-info-text {
            color: #999999;
            font-size: 12px;
            line-height: 18px;
            flex: 1;
            width: 0;
            word-break: break-all;
          }
          .del-icon {
            font-size: 14px;
            color: #999;
            padding: 3px 5px;
            padding-right: 0;
            cursor: pointer;
          }
        }
      }
    }
  }
}
.case-report-creator-tools {
  box-sizing: border-box;
  width: calc(100% + 40px);
  border-top: 1px solid #e6e6e6;
  padding: 12px 20px;
  margin-left: -20px;
  margin-bottom: -20px;
}
</style>



// WEBPACK FOOTER //
// src/views/cases/components/caseReportCreator.vue